<template>
    <div class="badges" v-if="isInited">
        <div class="left">
            <div class="left-wrap">
                <span class="block-head">Badges</span>
                <span class="block-desc open-sans">
                    Receive valuable badges!
                </span>
                <div class="badges-main">

                    <div v-for="(badge, index) in badges" :key="index" :class="{'act': badge.is_received}" @click="open = badge" class="item">
                        <img v-if="badge.data && (badge.is_received ? badge.data.icon_active : badge.data.icon)" :src="badge.is_received ? badge.data.icon_active : badge.data.icon">
                    </div>

                </div>
            </div>
        </div>
        <div class="right">
            <div v-if="open && open.data" class="badges-select">
                <div class="img">
                    <img v-if="open.data.image" :src="open.data.image" />
                </div>
                <div v-if="open.is_received" class="gal"></div>
                <span class="head">{{ open.name }}</span>
                <span class="desc open-sans">{{ open.data.description }}</span>
                <div class="share">
                    <!-- <a href="#" class="vk"></a> -->
                    <!-- <a href="#" class="fb"></a> -->
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppBadges',
  data () {
    return {
      open: null
    }
  },
  watch: {
    isInited () {
      if (this.badges && this.badges.length && !this.open) {
        this.open = this.badges[0]
      }
    }
  },
  computed: {
    ...mapGetters(['badgeList', 'isInited']),
    badges () {
      let badges = []
      if (this.badgeList) {
        badges = [...this.badgeList.oneLevelBadges]
        if (this.badgeList.multilevelBadges.length) {
          this.badgeList.multilevelBadges.forEach(level => {
            badges = [...badges, ...level]
          })
        }
      }
      return badges
    }
  }
}
</script>
